import { render, staticRenderFns } from "./ManterAcompanhamentoDeTurmasProfessor.vue?vue&type=template&id=68ec73de"
import script from "./ManterAcompanhamentoDeTurmasProfessor.vue?vue&type=script&lang=js"
export * from "./ManterAcompanhamentoDeTurmasProfessor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports